import { Pressable } from 'react-native'
import { styled } from '~/core/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      width: '100%',
      minWidth: theme.sizingExtrasmall * theme.sizingTiny,
      flexDirection: 'row',
      gap: theme.spacingInlineTwopulse,
      padding: theme.paddingInsetFourpulse,
      borderRadius: theme.borderRadiusPill,
      backgroundColor: theme.colorActionFillNeutralTertiaryEnabled,

      alignItems: 'center',
      overflow: 'hidden',
    },
    variants: {
      hasPressed: {
        true: {
          backgroundColor: theme.colorActionFillNeutralTertiaryPressed,
        },
      },
    },
  }
})
